import { render, staticRenderFns } from "./ActivateAccount.vue?vue&type=template&id=4fdd3a26"
import script from "./ActivateAccount.vue?vue&type=script&lang=js"
export * from "./ActivateAccount.vue?vue&type=script&lang=js"
import style0 from "./ActivateAccount.vue?vue&type=style&index=0&id=4fdd3a26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports